import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[qtColumnFormatDef]',
  standalone: false,
})
export class ColumnFormatDirective {
  /** Column format of value. */
  @Input('qtColumnFormatDef') format: string;

  constructor(public templateRef: TemplateRef<any>) {}
}
